module.exports = __webpack_public_path__ + "static/media/client12.f6dfc742.webp";